import React from 'react';
import ReactDOM from 'react-dom';
import GlobalSearchDropdown from "../../js/global-search-dropdown.es6.js";
import SearchBar
  from "../components/search-bar/search-bar.jsx";
import GlobalSearchDropdownSearchResult
  from "../components/global-search-dropdown-search-results/global-search-dropdown-search-result.jsx";
import Mark from 'mark.js'
import ElementService from "./services/element-service.js";
import SearchApiService from "./services/search-api-service.js";
import AwesomeDebouncePromise from 'awesome-debounce-promise';
const DESKTOP_BREAKPOINT = 1023;

export default class GlobalSearchDropdownContainer {
  constructor() {
    this.elementService = new ElementService();
    this.searchApiService = new SearchApiService();
    this.globalSearchDropdown = new GlobalSearchDropdown();
    this.globalSearchDropdownDiv = document.getElementById('block-globalsearchdropdown');
    this.dumpedLabelsContainer = this.globalSearchDropdownDiv.querySelector('.dumped-labels');
    this.placeholderText = this.globalSearchDropdownDiv.querySelector('.field--name-field-plain-text-2').textContent;
    this.searchButtonText = this.globalSearchDropdownDiv.querySelector('.field--name-field-plain-text-5').textContent;
    this.searchResultsContainers = this.globalSearchDropdownDiv.querySelectorAll('.search-results--container');
    this.commonSearchesWrappers = this.globalSearchDropdownDiv.querySelectorAll('.common-searches--wrapper');
    this.findWrappers = this.globalSearchDropdownDiv.querySelectorAll('.find--wrapper');
    this.searchBarForms = [];
    this.providersResultsWrappers = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.results--wrapper.provider');
    this.locationResultsWrappers = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.results--wrapper.location')
    this.allResultsWrappers = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.results--wrapper.all');
    this.loadingBoxes = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.loading-box');
    this.markInstance = this.setMarkInstance();
    this.clearButtons = [];
    this.allResButtons = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.field--name-field-seafoam-button');
    this.originalSeeAllButtonHref = this.allResButtons[0].href;
    this.originalProvidersHref = document.querySelector('.results--wrapper.provider .field--name-field-link a').href;
    this.originalLocationsHref = document.querySelector('.results--wrapper.location .field--name-field-link-2 a').href;
    this.onInputChange = this.onInputChange.bind(this);
    this.onFormReset = this.onFormReset.bind(this);
    this.searchApiBinding = searchedText => this.filterResults(searchedText);
    this.onSubmit = this.onSubmit.bind(this);
    this.searchAPIDebounced = AwesomeDebouncePromise(this.searchApiBinding, 500);
    this.url = new URL(window.location);
  }

  setMarkInstance() {
    const allRes = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.all-results--container');
    const provRes = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.provider-results--container');
    const locationRes = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.location-results--container');
    return new Mark(allRes.concat(provRes).concat(locationRes));
  }

  showResults(topThreeResults, topThreeProviderResults, topThreeLocationResults) {
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.loadingBoxes, false);

    if (topThreeResults.length > 0) {
      this.showTopThreeResults(topThreeResults);
    } else {
      this.elementService.toggleVisibleStateOfAllElementsInArray(this.allResultsWrappers, false);
    }

    if (topThreeProviderResults.length > 0) {
      this.showTopThreeProviderResults(topThreeProviderResults)
    } else {
      this.elementService.toggleVisibleStateOfAllElementsInArray(this.providersResultsWrappers, false);
    }

    if (topThreeLocationResults.length > 0) {
      this.showTopThreeLocationResults(topThreeLocationResults)
    } else {
      this.elementService.toggleVisibleStateOfAllElementsInArray(this.locationResultsWrappers, false);
    }
  }

  showTopThreeResults(topThreeResults) {
    const allResContainers = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.all-results--container')
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.allResultsWrappers, true);


    allResContainers.forEach(container => {
      ReactDOM.render(
        <>
          {topThreeResults.map(result => {
            const resTitle = result['field_title'] > 0 ? result['field_title'] : result.title;
            return (
              <GlobalSearchDropdownSearchResult
                key={`global-search-dropdown-search-result${resTitle}`}
                nodeLink={resTitle}
              />
            );
          })}
        </>,
        container
      );
    })
  }

  showTopThreeProviderResults(topThreeProviderResults) {
    const provResContainers = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.provider-results--container')
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.providersResultsWrappers, true);

    provResContainers.forEach(container => {
      ReactDOM.render(
        <>
          {topThreeProviderResults.map(result => {
            return (
              <GlobalSearchDropdownSearchResult
                key={`global-search-dropdown-search-result${result.title}`}
                nodeLink={result.title}
              />
            );
          })}
        </>,
        container
      );
    })
  }

  showTopThreeLocationResults(topThreeLocationResults) {
    const locResContainers = this.elementService.getChildElementsByClass(this.searchResultsContainers, '.location-results--container')
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.locationResultsWrappers, true);

    locResContainers.forEach(container => {
      ReactDOM.render(
        <>
          {topThreeLocationResults.map(result => {
            return (
              <GlobalSearchDropdownSearchResult
                key={`global-search-dropdown-search-result${result.title}`}
                nodeLink={result.title}
              />
            );
          })}
        </>,
        container
      );
    })
  }

  showLoadingResults() {
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.loadingBoxes, true);
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.allResultsWrappers, false);
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.locationResultsWrappers, false);
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.providersResultsWrappers, false);
  }

  hideResults() {
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.clearButtons, false);
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.searchResultsContainers, false);
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.commonSearchesWrappers, true);
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      this.elementService.toggleVisibleStateOfAllElementsInArray(this.findWrappers, true);
    }
  }

  async onSubmit(event) {
    event.preventDefault();
    let searchedText;
    for (const form of this.searchBarForms) {
      searchedText = form.querySelector('.site-search-search-bar').value.length > 0 ? form.querySelector('.site-search-search-bar').value : ''
      if (searchedText.length > 0) {
        break;
      }
    }
    if (this.allResButtons) {
      this.allResButtons[0].click();
    }
  }

  onFormReset(event) {
    this.searchBarForms.forEach(form => {
      form.reset()
    });
    this.hideResults();
  }

  updateAllResultsUrls(searchedText) {
    const updatedUrl = `${this.originalSeeAllButtonHref}?search=${searchedText}`
    this.allResButtons.forEach(button => {
      button.href = updatedUrl;
    });

    // update provider link
    const providerLink = document.querySelector('.results--wrapper.provider .field--name-field-link a');
    providerLink.href = `${this.originalProvidersHref}?search=${searchedText}`;

    // update locations link
    const locationsLink = document.querySelector('.results--wrapper.location .field--name-field-link-2 a');
    locationsLink.href = `${this.originalLocationsHref}?search=${searchedText}`;
  }

  async onInputChange(event) {
    const searchedText = event.target.value;
    if (searchedText.length > 2) {
      this.updateAllResultsUrls(searchedText);
      this.showLoadingResults();
      const results = await this.searchAPIDebounced(searchedText);
      this.showResults(results.topThreeResults, results.topThreeProviderResults, results.topThreeLocationResults);
      this.highlightSearchedText(searchedText);
      this.elementService.toggleVisibleStateOfAllElementsInArray(this.clearButtons, true);
    } else {
      this.hideResults(searchedText);
    }
  }

  highlightSearchedText(searchedText) {
    this.markInstance.unmark();
    this.markInstance.mark(searchedText);
  }

  async filterResults(searchedText) {
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.commonSearchesWrappers, false);
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      this.elementService.toggleVisibleStateOfAllElementsInArray(this.findWrappers, false);
    }
    this.elementService.toggleVisibleStateOfAllElementsInArray(this.searchResultsContainers, true);
    const allResults = (await this.searchApiService.searchContentWithNoProvidersOrLocationsByTitle(searchedText)).rows;
    const topThreeResults = await allResults.slice(0, 3);
    const providerResults = (await this.searchApiService.searchProvidersByName(searchedText)).rows;
    const topThreeProviderResults = await providerResults.slice(0, 3);
    const locationResults = (await this.searchApiService.searchLuminisLocationByName(searchedText)).rows;
    const topThreeLocationResults = await locationResults.slice(0, 3);

    return {
      topThreeResults,
      topThreeProviderResults,
      topThreeLocationResults
    };
  }

  filterProviderResults(allResults) {
    return allResults.filter(result => {
      return result.type.toLowerCase().includes('provider')
    });
  }

  async initContainer() {
    const searchContainerDivs = this.globalSearchDropdownDiv.querySelectorAll('.search-bar--container');
    searchContainerDivs.forEach(container => {
      ReactDOM.render(
        <>
          <SearchBar
            key={ 'global-search-search-bar' }
            placeholderText={ this.placeholderText }
            searchButtonText={ this.searchButtonText }
            onInputChange={ this.onInputChange }
            onFormReset={ this.onFormReset }
            onSubmit={ this.onSubmit }
          />
        </>,
        container
      );
    })
    this.clearButtons = this.globalSearchDropdownDiv.querySelectorAll('.clear-button--label');
    this.searchBarForms = Array.from(this.globalSearchDropdownDiv.querySelectorAll('.search-bar--form'));
  }
}

(async () => {
  if (document.querySelector(
    '.global-search-dropdown',
  )) {
    const globalSearchDropdownContainer = new GlobalSearchDropdownContainer();
    await globalSearchDropdownContainer.initContainer();
  }
})(Drupal);
